import React, {
    useState
} from 'react';

import { 
    useIonViewWillEnter,
    useIonRouter,
    IonPage,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonGrid,
    IonRow,
    IonCol,
    IonButtons,
    IonButton,
    IonBackButton,
    NavContext,
    IonLabel,
    IonItem,
    IonInput,
    IonCard,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCardContent,
    IonText,
    IonImg,
    IonIcon
} from '@ionic/react';
import { barChartOutline, shuffleOutline, person, cash, paperPlane, wallet, caretForward } from "ionicons/icons";
import { RouteComponentProps } from "react-router-dom";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';  


interface ExProp extends RouteComponentProps<{
    amount : string
    }> 
{} 

const NtkExConfirm : React.FC<ExProp> = ({match}) => {

    const [exchange, setExchange] = useState("");
    const [xrate, setXrate] = useState("");
    const [amount, setAmount] = useState("");
    const [left, setLeft] = useState(0);
    const [canSend, setCanSend] = useState(false);
    const [msg, setMsg] = useState('');

    //	Initializing our router
	const router = useIonRouter();

    useIonViewWillEnter(() => {
        getData();
    });

    const getData = async () => {
        
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            amount : match.params.amount
        }

		var server = new NServer();
        await server.getList("ntk_ex_confirm", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setExchange(server.data.exchange);
            setLeft(server.data.left);
            setXrate(server.data.xrate);
            setMsg(server.data.msg);
            setCanSend((server.data.can == "yes"));
        }
	};

    // when save the passcode
    const submit = () => {
        router.push('/ntk_ex_pass/' + match.params.amount, "forward", "push");
    };

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/ntk_exchange" ></IonBackButton>
                    </IonButtons>

                    <IonTitle className="title"><h5>{ GetStr(LANGUAGE.TXT_NTK_USD_EX_CAP) }</h5></IonTitle>
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <IonImg className="icon-pic ion-margin-top" src="/assets/img/dollar_pic.png" />
                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <div>{ GetStr(LANGUAGE.TXT_USD_EX_EXCHANGE) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={shuffleOutline} slot="start"></IonIcon>
                                        <b>{exchange}</b>
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_USD_EX_XRATE) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={barChartOutline} slot="start"></IonIcon>
                                        <b>$ {xrate}</b>
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_USD_EX_RECEIVE) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={cash} slot="start"></IonIcon>
                                        <b>$ {match.params.amount}</b>
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_NTK_LEFT) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={wallet} slot="start"></IonIcon>
                                        <IonText color={ left < 0 ? "danger" : "" }><b>{left}</b></IonText>
                                    </IonItem>
                                    <div>{ msg }</div>
                                    <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={submit} disabled={!canSend}>
                                        { GetStr(LANGUAGE.TXT_USD_EXCHANGE_BUT) }
                                    </IonButton>
                                </IonCardContent>
                            </IonCard>
                            </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default NtkExConfirm;